import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import { AppShell } from '@/components/layout/AppShell';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import TenantsPage from '@/pages/TenantsPage';
import TenantDetailPage from '@/pages/TenantDetailPage';
import BrandProfilePage from '@/pages/BrandProfilePage';
import PromptsPage from '@/pages/PromptsPage';
import ContentCreatorPage from '@/pages/ContentCreatorPage';
import ContentLibraryPage from '@/pages/ContentLibraryPage';
import JobsMonitorPage from '@/pages/JobsMonitorPage';
import AdminOverviewPage from '@/pages/AdminOverviewPage';
import CreditManagementPage from '@/pages/CreditManagementPage';
import VideoCreatorPage from '@/pages/VideoCreatorPage';
import LongVideoStudioPage from '@/pages/LongVideoStudioPage';
import ContentCalendarPage from '@/pages/ContentCalendarPage';
import PortfolioPage from '@/pages/PortfolioPage';
import VideoEditorPage from '@/pages/VideoEditorPage';
import SettingsPage from '@/pages/SettingsPage';
import SportsManagePage from '@/pages/SportsManagePage';
import MatchCenterPage from '@/pages/MatchCenterPage';
import BookmakerSettingsPage from '@/pages/BookmakerSettingsPage';
import AutomationRulesPage from '@/pages/AutomationRulesPage';
import SportsTemplatesPage from '@/pages/SportsTemplatesPage';
import SocialChannelsPage from '@/pages/SocialChannelsPage';
import XConnectionPage from '@/pages/XConnectionPage';
import LandingPage from '@/pages/LandingPage';
import SiteManagementPage from '@/pages/SiteManagementPage';
import StaticPage from '@/pages/StaticPage';
import '@/App.css';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-[#A3A3A3] font-ibm text-sm" data-testid="loading-screen">Yükleniyor...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/sayfa/:slug" element={<StaticPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/sports/manage" element={<SportsManagePage />} />
        <Route path="/sports/matches" element={<MatchCenterPage />} />
        <Route path="/sports/bookmakers" element={<SocialChannelsPage />} />
        <Route path="/sports/social" element={<SocialChannelsPage />} />
        <Route path="/social/x" element={<XConnectionPage />} />
        <Route path="/sports/templates" element={<SportsTemplatesPage />} />
        <Route path="/sports/automation" element={<AutomationRulesPage />} />
        <Route path="/tenants" element={<TenantsPage />} />
        <Route path="/tenants/:id" element={<TenantDetailPage />} />
        <Route path="/tenants/:tenantId/brand" element={<BrandProfilePage />} />
        <Route path="/brand" element={<BrandProfilePage />} />
        <Route path="/prompts" element={<PromptsPage />} />
        <Route path="/content/create" element={<ContentCreatorPage />} />
        <Route path="/video/create" element={<VideoCreatorPage />} />
        <Route path="/video/long" element={<LongVideoStudioPage />} />
        <Route path="/video/editor" element={<VideoEditorPage />} />
        <Route path="/calendar" element={<ContentCalendarPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/content/library" element={<ContentLibraryPage />} />
        <Route path="/jobs" element={<JobsMonitorPage />} />
        <Route path="/admin" element={<AdminOverviewPage />} />
        <Route path="/admin/credits" element={<CreditManagementPage />} />
        <Route path="/admin/site" element={<SiteManagementPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
